import { safeDiagnosticUrl } from './diag-trace'

const SESSION_KEY = '__spotty_diag_session'
let fallbackSession: string | undefined

export function diagnosticId(): string {
  try {
    return crypto.randomUUID()
  } catch {
    // Diagnostics still work in restricted WebViews without secure-context APIs.
    // eslint-disable-next-line sonarjs/pseudo-random
    return `diag-${String(Date.now())}-${Math.random().toString(36).slice(2)}`
  }
}

export function diagnosticSessionId(): string {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY)
    if (existing) return existing
    const id = diagnosticId()
    sessionStorage.setItem(SESSION_KEY, id)
    return id
  } catch {
    fallbackSession ??= diagnosticId()
    return fallbackSession
  }
}

export function diagnosticEnvironment(): string {
  const hostname = typeof window === 'undefined' ? '' : window.location.hostname
  if (hostname === 'spotty.one' || hostname === 'www.spotty.one') return 'production'
  if (
    import.meta.env.DEV ||
    hostname === 'dev.spotty.one' ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1'
  )
    return 'development'
  return 'preview'
}

export function diagnosticContext() {
  return {
    sessionId: diagnosticSessionId(),
    environment: diagnosticEnvironment(),
    releaseSha: import.meta.env.VITE_RELEASE_SHA ?? 'unknown',
    userAgent: typeof navigator === 'undefined' ? '' : navigator.userAgent.slice(0, 512),
    pageUrl: typeof window === 'undefined' ? '' : safeDiagnosticUrl(window.location.href),
    viewport:
      typeof window === 'undefined'
        ? ''
        : `${String(window.innerWidth)}x${String(window.innerHeight)}`,
    pixelRatio: typeof window === 'undefined' ? 1 : window.devicePixelRatio,
    visibility: typeof document === 'undefined' ? 'unknown' : document.visibilityState,
  }
}
